import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnas } from "./columns";

type Entity = models.ViajeCobranzaDto;
export interface Props {
    value: Entity[];
}

/**
* Listado de 
*/
class ViajesRevisionListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    onVer = async (x: Entity) => {
        history.go("./" + x.IdRegistro);
    }

    onImprimir = async (x: Entity) => {
        const data = await resources.Cobranza2.ImprimirViaje(x.IdRegistro);
        kea.printPdf(data);
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const ViajesRevisionList = kea.mapProps(componentToRx(ViajesRevisionListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/list/listmem.tsx